common.View.create('shop::website.modules.shopCheckout.cart.partials.Amount', {

    onDOMLoad()
    {
        this.initCart();
    },

    async initCart()
    {
        let response = await $.get(this.element.data('url') + '/get-cart/');

        // Update amount in header.
        $('.website\\:\\:layouts-main-Header').data('instance')
            .setTotalPhysicalAmount(response.totalPhysicalAmount);

        // Update mini cart
        $('.shop\\:\\:website-modules-shopCheckout-cart-partials-MiniCart').data('instance')
            .replaceMiniCart(response.miniCartView, false);
    },
});
